import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IsAuthenticated from '../partials/IsAuthenticated';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface IMainLayout {
  children?: React.ReactNode,
  showFooter?: boolean,
  headerTitle: string,
  subtitle?: string
}

const Layout: React.FC<IMainLayout> = ({ children, showFooter = true, headerTitle, subtitle }) => {
  return (
    <IsAuthenticated>
      <Box sx={{
        flexGrow: 1,
        minWidth: '494px',
        display: "flex",
        flexDirection: "column"
      }}>
        <Header title={headerTitle} subtitle={subtitle} />
        <Grid container spacing={1} sx={{ height: 'calc(100vh - 5.9em)', overflowY: 'hidden', width: '100%' }}>
          {children}
        </Grid>
        { showFooter && <Footer /> }
      </Box>
    </IsAuthenticated>
  );
}

export default Layout;